type PrefixMatch = [matched: boolean, params: string[]]

export const getPrefixMatch = (
  path: string[],
  ...prefix: string[]
): PrefixMatch => {
  const matched = prefix.every((segment, index) => segment === path[index])

  return [matched, path.slice(prefix.length, path.length)]
}
